// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { LMoperationHours } from './types';

export interface ActionGetLMOperationHoursAPI extends Action {
  listingId: string
}

export const getLMOperationHoursAPI = (listingId: string): ActionGetLMOperationHoursAPI => ({
  type: ACTIONS.GET_LMOPERATIONHOURS_API_REQUEST,
  listingId,
});

export interface ActionGetLMOperationHoursAPISuccess extends Action {
  lmoperationHours: LMoperationHours
}

export const getLMOperationHoursAPISuccess = (lmoperationHours: LMoperationHours): ActionGetLMOperationHoursAPISuccess => ({
  type: ACTIONS.GET_LMOPERATIONHOURS_API_SUCCESS,
  lmoperationHours
});

export const getLMOperationHoursAPIError = (): Action => ({
  type: ACTIONS.GET_LMOPERATIONHOURS_API_ERROR,
});


export interface ActionPostLMOperationHoursAPI extends Action {
  listingId: string;  
  operationHours: LMoperationHours
}

export const postLMOperationHoursAPI = (listingId: string, operationHours: LMoperationHours): ActionPostLMOperationHoursAPI => ({
  type: ACTIONS.POST_LMOPERATIONHOURS_API_REQUEST,
  listingId,
  operationHours
});

export interface ActionPostLMOperationHoursAPISuccess extends Action {
  lmoperationHours: LMoperationHours
}

export const postLMOperationHoursAPISuccess = (lmoperationHours: LMoperationHours): ActionPostLMOperationHoursAPISuccess => ({
  type: ACTIONS.POST_LMOPERATIONHOURS_API_SUCCESS,
  lmoperationHours
});

export const postLMOperationHoursAPIError = (): Action => ({
  type: ACTIONS.POST_LMOPERATIONHOURS_API_ERROR,
});